export default __webpack_public_path__ + "static/media/gym-img-25.3bc88fd4.jpg";